import { __awaiter, __generator } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { httpGet } from '@office-start/xhr-service';
import { createRequestConfig } from './createRequestConfig';
export function getWorkspaces(workspacesApiOptions, strategy) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var endpoint = (workspacesApiOptions.inMockMode
                        ? workspacesApiOptions.officeHomeApiRoot
                        : workspacesApiOptions.myApplicationsUrl) +
                        '/api/me/getExpandedAssignedWorkspaces';
                    var requestConfig = createRequestConfig(workspacesApiOptions);
                    httpGet(KnownInstrumentationEvents.ExpandedWorkspacesRequest, "Expanded_Workspaces" /* KnownRequestInstrumentationEvents.ExpandedWorkspacesRequest */, endpoint.toString(), requestConfig, workspacesApiOptions.jwtAuthEnabled, workspacesApiOptions.getAccessToken, workspacesApiOptions.officeHomeApiRoot, workspacesApiOptions.correlationId, 'MyApps', {}, strategy)
                        .then(function (response) {
                        if (response && response.data) {
                            resolve({
                                workspaces: response.data,
                                fromCache: strategy === "cache-only" /* FetchStrategy.CacheOnly */,
                            });
                        }
                        else {
                            reject();
                        }
                    })
                        .catch(function (error) {
                        getErrorHandler().handleError(error);
                        reject("Failed to get Expanded Workspaces. Status Code: ".concat(error && error.httpResponse
                            ? error.httpResponse.status
                            : ''));
                    });
                })];
        });
    });
}
//# sourceMappingURL=getWorkspaces.js.map